import React from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import AiVideo from "./index"; // The inner component without MainContainer

const AiVideoModal = ({ open, onClose, onVideoGenerated }) => {
  const theme = useTheme();

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="xl" 
      fullWidth
      PaperProps={{
        style: {
          width: "95vw",
          maxWidth: "95vw",
          borderRadius: 16,
          border: `1px solid ${theme.palette.primary.main}`,
          boxShadow: theme.palette.type === "dark" 
            ? `0 0 20px ${theme.palette.primary.main}80` 
            : `0 0 16px ${theme.palette.primary.main}40`,
          overflow: "hidden"
        }
      }}
    >
      <DialogTitle style={{ padding: '12px 24px', backgroundColor: theme.palette.type === 'dark' ? '#1E2126' : '#f5f5f5', color: theme.palette.type === 'dark' ? '#fff' : '#111' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontWeight: 700, fontSize: "1.1rem" }}>Generador de Video IA (Ads)</span>
          <IconButton onClick={onClose} size="small" style={{ color: theme.palette.type === 'dark' ? '#fff' : '#111' }}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <AiVideo onVideoGenerated={onVideoGenerated} />
      </DialogContent>
    </Dialog>
  );
};

export default AiVideoModal;
